import { useQuery, gql } from '@apollo/client';

export const GET_PROJECT_BY_ID = gql`
  query getProjectById($projectId: String!) {
    getProjectById(projectId: $projectId) {
      _id
      name
      projectNumber
      details
      startDate
      createdAt
      createdBy
      status
      ganttIds
      plannedHours
      gantts {
        name
      }
      address {
        street
        city
        country
        zipCode
      }
      customerId
      companyId
      customer {
        name
        deleted
      }
      ownerMemberId
      ownerMember {
        profile {
          firstName
          lastName
        }
      }
      deputyMemberId
      deputyMember {
        profile {
          firstName
          lastName
        }
      }
      tasks {
        _id
        name
        notes
        plannedHours
        files {
          _id
          location
          filename
          key
        }
        timeStripes {
          _id
          name
          plannedHours
          startDate
          ganttId
          gantt {
            name
          }
        }
      }
    }
  }
`;

export const useGetProjectById = ({ projectId }: { projectId: string }) => {
  const { data, loading } = useQuery(GET_PROJECT_BY_ID, {
    variables: { projectId },
    fetchPolicy: 'network-only',
  });

  const project = data?.getProjectById || {};

  return {
    project,
    loading,
  };
};
